import React from 'react';

import { Modal } from 'fpay-ui';

import { useCommon, useBreakpoint } from '@hooks';

const ModalContainer = () => {
  const { modal } = useCommon();
  const { mobile } = useBreakpoint();

  return (
    <>
      {modal?.open && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Modal {...modal} width={`${mobile ? '312' : '400'}px`}>
          {modal.body}
        </Modal>
      )}
    </>
  );
};

export default ModalContainer;
